import { ReactComponent as CrossIcon } from 'assets/icon/x-circle.svg';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import Textarea from 'components/common/textarea-field';
import PrimaryDarkButton from 'components/common/buttons/primary-dark-btn';
import DarkButton from 'components/common/buttons/dark-btn';
import InputField from 'components/common/input-field';
import { setModal } from 'store/features/modelSlice';
import { initModal, modalEnum } from 'helpers/utils';
import Select, { IDefaultOption } from 'components/common/select';
import { useContext, useEffect, useState } from 'react';
import {
  IAlertDropdownOption,
  IAlertTemplateItem,
  getAlertsTemplates,
  generateAlert,
  setSelectAlertTemplate,
  getAlertsList,
} from 'store/features/alertsSlice';
import { AppContext } from 'context/app-context';
import {
  getBrandList,
  getEngineList,
  // getModelsList,
  getTireSizeList,
} from 'store/features/vehicleConfigSlice';
import CloudUpload from 'components/common/cloud-upload';
import { ReactComponent as FileIcon } from 'assets/icon/file-icon.svg';
import { ReactComponent as TrashIcon } from 'assets/icon/trash.svg';
import { IAlertItems } from 'pages/private/alerts/types';
import { useTranslation } from 'react-i18next';

interface ISendAlertsData {
  brand?: IDefaultOption | null;
  model?: IDefaultOption | null;
  engine?: IDefaultOption | null;
  frontTireSize?: IDefaultOption | null;
  rearTireSize?: IDefaultOption | null;
  alertDetails: IAlertTemplateItem;
}

const initAlertDetails = {
  title: '',
  description: '',
  referenceCode: '',
};

interface IError {
  alertTitle?: string;
  alertDescription?: string;
  referenceCode?: string;
}
const SendAlert = () => {
  const { setLoader } = useContext(AppContext);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { brands, engines, models, tireSizes } = useAppSelector(state => state.vehicleConfig);
  const {
    modal: {
      content: { callBackFun },
    },
  } = useAppSelector(state => state.modal);

  const [alertsData, setAlertsData] = useState<ISendAlertsData | null>(null);
  const [error, setError] = useState<IError | null>(null);
  const [dropdownSearch, setDropdownSearch] = useState<string>('');
  const [brandOptions, setBrandOptions] = useState<IDefaultOption[]>([]);
  // const [modelOptions, setModelOptions] = useState<IDefaultOption[]>([]);
  const [engineOptions, setEngineOptions] = useState<IDefaultOption[]>([]);
  const [tireSizeOptions, settireSizeOptions] = useState<IDefaultOption[]>([]);
  const [selectedCSVFile, setSelectedCSVFile] = useState<File | null>(null);
  const [pagination, setPagination] = useState({
    offset: 0,
    limit: 20,
  });
  const fetchOptions = async () => {
    try {
      setLoader(true);
      await Promise.all([
        dispatch(getBrandList({})),
        // dispatch(getModelsList({})),
        dispatch(getEngineList({})),
        dispatch(getTireSizeList({})),
        dispatch(getAlertsTemplates()),
      ]);
      setLoader(false);
    } catch (error) {}
  };
  useEffect(() => {
    fetchOptions();
  }, []);
  useEffect(() => {
    const formatedBrandOptions =
      brands.map(data => ({ id: data?._id || '', name: data?.name || '' })) || [];
    setBrandOptions(formatedBrandOptions);
  }, [brands]);
  // useEffect(() => {
  //   if (alertsData?.brand) {
  //     const filteredModel =
  //       models.filter(
  //         data => data?.brandDetails?._id === (alertsData?.brand?.id || alertsData?.brand?._id),
  //       ) || [];

  //     const formatedModelOptions =
  //       filteredModel.map(data => ({ id: data?._id || '', name: data?.name || '' })) || [];
  //     setModelOptions(formatedModelOptions);
  //   }
  // }, [alertsData?.brand]);
  useEffect(() => {
    const formatedEngineOptions =
      engines.map(data => ({ id: data?._id || '', name: data?.name || '' })) || [];
    setEngineOptions(formatedEngineOptions);
  }, [engines]);
  useEffect(() => {
    const formatedTireSizeOptions =
      tireSizes.map(data => ({ id: data?._id || '', name: data?.name || '' })) || [];
    settireSizeOptions(formatedTireSizeOptions);
  }, [tireSizes]);
  useEffect(() => {});
  const handleChange = (field: string, value: IAlertDropdownOption) => {
    const updatedValue: ISendAlertsData = {
      ...alertsData,
      alertDetails: alertsData?.alertDetails ? alertsData?.alertDetails : initAlertDetails,
      [field]: value,
    };
    setAlertsData(updatedValue ? updatedValue : null);
  };
  const handleGenerateAlert = () => {
    try {
      if (
        !alertsData?.alertDetails?.title.trim() ||
        !alertsData?.alertDetails?.description?.trim() ||
        !alertsData?.alertDetails?.referenceCode?.trim()
      ) {
        setError({
          alertTitle: !alertsData?.alertDetails?.title?.trim()
            ? t('campaigns.title_error_message')
            : '',
          alertDescription: !alertsData?.alertDetails?.description?.trim()
            ? t('campaigns.description_error_message')
            : '',
          referenceCode: !alertsData?.alertDetails?.referenceCode?.trim()
            ? t('campaigns.referanceCode_error_message')
            : '',
        });
        return true;
      }
      setLoader(true);
      const formData = new FormData();
      formData.append('title', alertsData?.alertDetails?.title || '');
      formData.append('description', alertsData?.alertDetails?.description || '');
      formData.append('alert_ref', alertsData?.alertDetails?.referenceCode || '');

      if (selectedCSVFile) {
        formData.append('VINs', selectedCSVFile);
      }
      if (alertsData?.brand) {
        formData.append('brand', alertsData?.brand?.id || '');
      }
      if (alertsData?.engine) {
        formData.append('engine', alertsData?.engine?.id || '');
      }
      if (alertsData?.frontTireSize) {
        formData.append('frontTireSize', alertsData?.frontTireSize?.id || '');
      }
      if (alertsData?.rearTireSize) {
        formData.append('rearTireSize', alertsData?.rearTireSize?.id || '');
      }
      // if (alertsData?.model) {
      //   formData.append('model', alertsData?.model?.id || '');
      // }
      dispatch(
        generateAlert({
          request: formData,
        }),
      ).then((res: IAlertItems) => {
        // dispatch(getAlertsList(0, 20));
        dispatch(
          getAlertsList({
            ...pagination,
          }),
        );
        dispatch(setSelectAlertTemplate(null));
        callBackFun && callBackFun();
        setLoader(false);
        dispatch(
          setModal({
            type: modalEnum?.ALERT_COMPLETE,
            content: {
              title: 'Campaign published',
              message: `Just wanted to let you know that we've sent out the campaign, and ${
                res?.user_count || 0
              } users are now notified about it..`,
              callBackFun: () => {
                dispatch(setModal(initModal));
              },
            },
          }),
        );
      });
    } catch (error) {
      setLoader(false);
    }
  };
  return (
    <div className="flex flex-col max-h-[calc(100vh-180px)] w-[600px] gap-y-4 overflow-hidden">
      <div className="flex items-center w-full">
        <div className="flex items-center flex-1">
          <label className="pl-2 text-xl font-semibold text-black2">
            {t('alerts.createCampaign')}
          </label>
        </div>
        <div
          className="flex items-center justify-center cursor-pointer"
          onClick={() => dispatch(setModal(initModal))}
        >
          <CrossIcon height={32} width={32} />
        </div>
      </div>
      <div className="flex flex-wrap w-full overflow-y-auto flex-1 gap-y-1">
        <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-full">{t('BRAND')}</label>
          <Select
            placeholder={t('campaigns.placeholder_brand')}
            selected={alertsData?.brand || null}
            options={
              brandOptions.filter(
                item => item?.name?.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
              ) || []
            }
            setSelected={data => handleChange('brand', data)}
            isSearchable
            search={dropdownSearch}
            setSearch={data => setDropdownSearch(data)}
            removeSearchOnBlur={true}
            showCross
            handleCross={() => {
              setAlertsData({
                ...alertsData,
                alertDetails: initAlertDetails,
                brand: null,
              });
            }}
          />
        </div>
        {/* <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-1/2w-full">{t('MODEL')}</label> */}
        {/* <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-1/2w-full">Models</label>
          <Select
            placeholder={t('campaigns.placeholder_model')}
            selected={alertsData?.model || null}
            options={
              modelOptions.filter(
                item => item?.name?.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
              ) || []
            }
            setSelected={data => handleChange('model', data)}
            isSearchable
            search={dropdownSearch}
            setSearch={data => setDropdownSearch(data)}
            removeSearchOnBlur={true}
          />
        </div> */}
        <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-full">{t('ENGINE')}</label>
          <Select
            placeholder={t('campaigns.placeholder_engine')}
            selected={alertsData?.engine || null}
            options={
              engineOptions.filter(
                item => item?.name?.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
              ) || []
            }
            setSelected={data => handleChange('engine', data)}
            isSearchable
            search={dropdownSearch}
            setSearch={data => setDropdownSearch(data)}
            removeSearchOnBlur={true}
            showCross
            handleCross={() => {
              setAlertsData({
                ...alertsData,
                alertDetails: initAlertDetails,
                engine: null,
              });
            }}
          />
        </div>
        <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-full">{t('FRONT_TIRE_SIZE')}</label>
          <Select
            placeholder={t('campaigns.placeholder_tire_size')}
            selected={alertsData?.frontTireSize || null}
            options={
              tireSizeOptions.filter(
                item => item?.name?.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
              ) || []
            }
            setSelected={data => handleChange('frontTireSize', data)}
            isSearchable
            search={dropdownSearch}
            setSearch={data => setDropdownSearch(data)}
            removeSearchOnBlur={true}
            showCross
            handleCross={() => {
              setAlertsData({
                ...alertsData,
                alertDetails: initAlertDetails,
                frontTireSize: null,
              });
            }}
          />
        </div>
        <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-full">{t('REAR_TIRE_SIZE')}</label>
          <Select
            placeholder={t('campaigns.placeholder_tire_size')}
            selected={alertsData?.rearTireSize || null}
            options={
              tireSizeOptions.filter(
                item => item?.name?.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
              ) || []
            }
            setSelected={data => handleChange('rearTireSize', data)}
            isSearchable
            search={dropdownSearch}
            setSearch={data => setDropdownSearch(data)}
            removeSearchOnBlur={true}
            showCross
            handleCross={() => {
              setAlertsData({
                ...alertsData,
                alertDetails: initAlertDetails,
                rearTireSize: null,
              });
            }}
          />
        </div>
        <div className="w-full">
          <label className="font-medium text-xs text-black2 w-full">
            {t('campaigns.tableHeaders.alert_ref')}
          </label>
          <InputField
            onChange={data =>
              setAlertsData({
                ...alertsData,
                alertDetails: {
                  referenceCode: data || '',
                  id: alertsData?.alertDetails?.id,
                  description: alertsData?.alertDetails?.description || '',
                  title: alertsData?.alertDetails?.title || '',
                },
              })
            }
            error={error?.referenceCode}
            value={alertsData?.alertDetails?.referenceCode || ''}
            placeholder={t('campaigns.tableHeaders.alert_ref')}
          />
        </div>
        <div className="w-full">
          <label className="font-medium text-xs text-black2 w-full">
            {t('campaigns.campaign_title')}
          </label>
          <InputField
            onChange={data =>
              setAlertsData({
                ...alertsData,
                alertDetails: {
                  title: data || '',
                  id: alertsData?.alertDetails?.id,
                  description: alertsData?.alertDetails?.description || '',
                  referenceCode: alertsData?.alertDetails?.referenceCode || '',
                },
              })
            }
            error={error?.alertTitle}
            value={alertsData?.alertDetails?.title || ''}
            placeholder={t('campaigns.placeholder_title')}
          />
        </div>
        <div className="w-full">
          <label className="font-medium text-xs text-black2 w-full">
            {t('campaigns.tableHeaders.description')}
          </label>
          <Textarea
            onChange={data =>
              setAlertsData({
                ...alertsData,
                alertDetails: {
                  title: alertsData?.alertDetails?.title || '',
                  id: alertsData?.alertDetails?.id,
                  description: data || '',
                  referenceCode: alertsData?.alertDetails?.referenceCode || '',
                },
              })
            }
            value={alertsData?.alertDetails?.description || ''}
            error={error?.alertDescription}
            row={2}
            placeholder={t('campaigns.placeholder_description')}
          />
        </div>
        <div className="w-full mt-2">
          <label className="font-semibold text-xs text-black2 w-full mb-1">
            {t('campaigns.csv_upload')}
          </label>
          <CloudUpload
            title={t('SEND_ALERT_MODAL_TITLE')}
            acceptedFile=".csv"
            setFile={e => {
              if (e?.target?.files?.length) {
                setSelectedCSVFile(e?.target?.files[0]);
              } else {
                e.stopPropagation();
              }
            }}
          />
        </div>
        {selectedCSVFile ? (
          <div className={`flex items-center border-1.5 rounded-1 border-grey h-[40px] w-1/2 mt-2`}>
            <div className="flex items-center flex-1 px-4 bg-white h-full">
              <div className="flex items-center flex-1 gap-x-1">
                <div className="flex items-center justify-center h-7 w-7 rounded-full bg-grey4">
                  <FileIcon height={16} width={16} />
                </div>
                <label className="text-black font-medium text-xs">
                  {selectedCSVFile ? selectedCSVFile?.name : 'No file chosen'}
                </label>
              </div>
              <div className="cursor-pointer" onClick={() => setSelectedCSVFile(null)}>
                <TrashIcon height={20} width={20} color="red" />
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="flex items-center justify-center gap-x-4 mt-4 w-2/3 self-center">
        <PrimaryDarkButton
          label={t('campaigns.publish_campaign_btn')}
          onClick={() => handleGenerateAlert()}
          width="w-1/2"
        />
        <DarkButton
          label={t('CANCEL')}
          width="w-1/2"
          onClick={() => {
            dispatch(setSelectAlertTemplate(null));
            dispatch(setModal(initModal));
          }}
        />
      </div>
    </div>
  );
};

export default SendAlert;
